var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.077,
    height: 48,
    viewBox: "0 0 59.077 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_039-sphere",
    "data-name": "039-sphere",
    transform: "translate(-22 -46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M81.077,68.154c0-2.441-2.169-4.478-6.447-6.055a1.837,1.837,0,0,0-.471-.1,23.943,23.943,0,0,0-3.98-7.11,1.858,1.858,0,0,0-.241-.324l-.169-.181,2.655-2.655a1.846,1.846,0,1,0-2.611-2.611L65.9,53.03a1.846,1.846,0,0,0-.044,2.565l.96,1.028A20.274,20.274,0,0,1,71.846,70c0,.424-.015.844-.04,1.261a61.219,61.219,0,0,1-12.2,2.107,1.846,1.846,0,0,0,.15,3.686q.076,0,.154-.006a72.383,72.383,0,0,0,11.245-1.791,20.309,20.309,0,0,1-39.229.012A74.378,74.378,0,0,0,43.865,77.1c.047,0,.094.005.14.005a1.846,1.846,0,0,0,.137-3.687,62.384,62.384,0,0,1-12.871-2.162c-.026-.417-.04-.836-.04-1.259A20.331,20.331,0,0,1,51.538,49.692a20.1,20.1,0,0,1,9.013,2.1,1.846,1.846,0,1,0,1.641-3.307A23.761,23.761,0,0,0,51.538,46a24.041,24.041,0,0,0-22.6,15.923c-4.6,1.6-6.939,3.7-6.939,6.231,0,2.621,2.5,4.5,5.871,5.831a23.922,23.922,0,0,0,5.45,11.622l-2.669,2.669a1.846,1.846,0,0,0,2.611,2.611l2.67-2.67A23.985,23.985,0,0,0,75.208,73.968C78.561,72.635,81.077,70.765,81.077,68.154Zm-55.385,0c0-.187.415-.891,2.118-1.764a24.1,24.1,0,0,0-.269,3.387C26.062,68.969,25.692,68.33,25.692,68.154Zm49.841,1.624a24.068,24.068,0,0,0-.273-3.392c1.717.88,2.124,1.588,2.124,1.768s-.367.814-1.851,1.624Z",
    transform: "translate(0)",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M111.846,156.769A1.846,1.846,0,0,1,110,154.923V143.846a1.846,1.846,0,0,1,2.954-1.477l7.385,5.538a1.846,1.846,0,0,1,0,2.954l-7.385,5.538A1.843,1.843,0,0,1,111.846,156.769Zm1.846-9.231v3.692l2.462-1.846Z",
    transform: "translate(-67.692 -73.846)",
    fill: "#051ee1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature6);
export default __webpack_public_path__ + "static/media/feature_6.6059d52cfc120b224c97818c35122e89.svg";
export { ForwardRef as ReactComponent };